import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://micopooldesign.com";
const DEFAULT_IMAGE = `${SITE_URL}/social-preview.jpg`;

function upsertMeta(selector, attributes) {
    let element = document.head.querySelector(selector);

    if (!element) {
        element = document.createElement("meta");
        document.head.appendChild(element);
    }

    Object.entries(attributes).forEach(([key, value]) => {
        element.setAttribute(key, value);
    });
}

function upsertCanonical(href) {
    let element = document.head.querySelector('link[rel="canonical"]');

    if (!element) {
        element = document.createElement("link");
        element.setAttribute("rel", "canonical");
        document.head.appendChild(element);
    }

    element.setAttribute("href", href);
}

export default function SEO({ title, description, image = DEFAULT_IMAGE }) {
    const { pathname } = useLocation();
    const url = `${SITE_URL}${pathname === "/" ? "" : pathname}`;

    useEffect(() => {
        document.title = title;

        upsertMeta('meta[name="description"]', {
            name: "description",
            content: description,
        });
        upsertMeta('meta[property="og:title"]', {
            property: "og:title",
            content: title,
        });
        upsertMeta('meta[property="og:description"]', {
            property: "og:description",
            content: description,
        });
        upsertMeta('meta[property="og:type"]', {
            property: "og:type",
            content: "website",
        });
        upsertMeta('meta[property="og:url"]', {
            property: "og:url",
            content: url,
        });
        upsertMeta('meta[property="og:image"]', {
            property: "og:image",
            content: image,
        });
        upsertMeta('meta[name="twitter:card"]', {
            name: "twitter:card",
            content: "summary_large_image",
        });
        upsertMeta('meta[name="twitter:title"]', {
            name: "twitter:title",
            content: title,
        });
        upsertMeta('meta[name="twitter:description"]', {
            name: "twitter:description",
            content: description,
        });
        upsertMeta('meta[name="twitter:image"]', {
            name: "twitter:image",
            content: image,
        });
        upsertCanonical(url);
    }, [description, image, title, url]);

    return null;
}
